import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { PaperIconComponent, PaperKbdComponent } from '@ricoh-paper/angular';
import { AppBrandIconComponent } from '../../../../../../shared/components/app-brand-icon/app-brand-icon.component';
import type { CmdkAppItem } from '../../models/cmdk.model';
import { CmdkAppProvider } from '../../services/cmdk-providers/app.provider';

/**
 * An app or quick link.
 *
 * The leading visual is the real brand mark — `im-app-brand-icon` resolves the
 * tenant's own uploaded image first, then the catalogue's SVG path, then a
 * generic glyph. That ordering matters: an admin who uploaded a logo expects
 * to see it, and 55 catalogue marks mean most links get a real one for free.
 *
 * A `<div role="option">`, not a button — see `cmdk-row-command`.
 */
@Component({
  selector: 'im-cmdk-row-app',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AppBrandIconComponent, PaperIconComponent, PaperKbdComponent],
  templateUrl: './cmdk-row-app.component.html',
  styleUrl: './cmdk-row-app.component.scss',
})
export class CmdkRowAppComponent {
  private readonly apps = inject(CmdkAppProvider);

  readonly item = input.required<CmdkAppItem>();
  readonly selected = input(false);
  readonly quickOpenIndex = input<number | null>(null);

  /** The source link, for its icon fields. */
  protected readonly link = computed(() => this.apps.linkFor(this.item().id));

  protected readonly quickOpenKey = computed(() => {
    const index = this.quickOpenIndex();
    return index === null ? null : String(index + 1);
  });
}
